import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import BrushIcon from '@material-ui/icons/Brush';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Tooltip } from 'antd';
import { getHTMLbaseOnDesign } from '../../../../redux/services';
import { isPublisherSelector } from '../../../../redux/selector';
import { Status } from '../SavingStatus';
import ABToggleButton from './ABToggleButton';
import MessageInfo from '../MessageInfo';
import PersonalizeSelect from '../PersonalizeSelect';
import BackButton from '../BackButton';
import {
  DraftNameInput,
  Header,
  SavingStatusText,
  ScreenTitle,
  IconButton,
} from './Header.styled';
import SendDraft from '../../../ViewMessage/SendDraft';
import PreviewDesignModal from '../../Modals/PreviewDesignModal';
import IconEmailCheck from './EmailCheckIcon';

const MESSAGE_BY_SAVE_STATUS = {
  [Status.SAVING]: 'Saving...',
  [Status.SAVED]: 'All changes saved',
  [Status.UNSAVED]: 'Unsaved changes',
};

const BaseHeader = ({
  className = null,
  isTitleHidden = false,
  isSaveStatusHidden = false,
  isNameHidden = false,
  menu,
  nextButton = null,
  backBtnTargetUrl,
  nameInputPlaceholder = 'Enter Name',
  messageInfoData,
  saveStatus,
  onUnsavedStatus,
  onNameChange,
  name,
  messageInfoRef,
  onSave,
  autosaveInterval = null,
  isDesignLoading,
  isABToggleEnabled,
  setABToggleEnabled,
  isConfirmDeleteABDraftModalVisible,
  setConfirmDeleteABDraftModalVisible,
  handleVersionChange,
  design,
}) => {
  const history = useHistory();
  const isPublisher = useSelector(isPublisherSelector);
  const [isSendDraftModalOpen, setIsSendDraftModalOpen] = useState(false);
  const [isDesignPreviewModalVisible, setDesignPreviewModalVisiblity] =
    useState(false);
  const [isLoadingPreview, setLoadingPreview] = useState(false);
  const [html, setHTML] = useState('');

  const openPreviewWindow = async () => {
    setLoadingPreview(true);
    const updatedHTML = await getHTMLbaseOnDesign(design);
    setHTML(updatedHTML);
    setDesignPreviewModalVisiblity(true);

    // this is a hack to give a moment for a preview screen to get an updated html design
    setTimeout(() => {
      setLoadingPreview(false);
    }, 500);
  };

  const openSendDraftDialog = async () => {
    setIsSendDraftModalOpen(true);
  };

  const getTooltip = () => {
    if (nameInputPlaceholder.includes('Draft')) {
      return 'Back to Drafts';
    }
    return 'Back to Templates';
  };

  return (
    <Header className={className}>
      <Header.LeftSide>
        {!isTitleHidden && !isPublisher && (
          <ScreenTitle>
            <BackButton
              onClick={() => {
                history.push(backBtnTargetUrl);
              }}
              tooltipText={getTooltip()}
            />
            <ScreenTitle.Text>
              <BrushIcon /> Design
            </ScreenTitle.Text>
          </ScreenTitle>
        )}
        {menu}
        {!isNameHidden && (
          <DraftNameInput
            placeholder={nameInputPlaceholder}
            value={name}
            onChange={({ target }) => {
              onNameChange(target.value);
            }}
            onFocus={event => {
              const $input = event.target;
              setTimeout(() => {
                $input.selectionStart = $input.selectionEnd =
                  $input.value.length;
              }, 0); // Chrome triggers focus event before setting cursor, so we should move the cursor only after it is first set
              $input.scrollTo($input.scrollWidth, 0);
            }}
            onBlur={event => {
              event.target.scrollTo(0, 0); // show the beginning of the name
            }}
          />
        )}
      </Header.LeftSide>
      <Header.RightSide>
        {!isSaveStatusHidden && (
          <SavingStatusText>
            {MESSAGE_BY_SAVE_STATUS[saveStatus]}
          </SavingStatusText>
        )}
        {isABToggleEnabled && (
          <ABToggleButton
            AB={messageInfoData.AB}
            draftId={messageInfoData._id}
            isSaving={saveStatus !== Status.SAVED}
            isDesignLoading={isDesignLoading}
            isABToggleEnabled={isABToggleEnabled}
            setABToggleEnabled={setABToggleEnabled}
            isConfirmDeleteABDraftModalVisible={
              isConfirmDeleteABDraftModalVisible
            }
            setConfirmDeleteABDraftModalVisible={
              setConfirmDeleteABDraftModalVisible
            }
            handleVersionChange={handleVersionChange}
          />
        )}
        {messageInfoRef && ( // I needed to add the following icons only for draft editor and if messageInfoRef exists
          <>
            <Tooltip
              title="Preview message"
              overlayInnerStyle={{ borderRadius: '5px' }}
            >
              <IconButton onClick={openPreviewWindow}>
                <VisibilityIcon />
              </IconButton>
            </Tooltip>
            <Tooltip
              title="Send Draft"
              overlayInnerStyle={{ borderRadius: '5px' }}
            >
              <IconButton onClick={openSendDraftDialog}>
                <IconEmailCheck />
              </IconButton>
            </Tooltip>
          </>
        )}
        {!isPublisher && (
          <MessageInfo
            ref={messageInfoRef}
            data={messageInfoData}
            onUnsavedStatus={onUnsavedStatus}
            onSave={onSave}
            autosaveInterval={autosaveInterval}
          />
        )}
        {!isPublisher && <PersonalizeSelect />}
        {nextButton}
      </Header.RightSide>
      {isSendDraftModalOpen && (
        <SendDraft
          draftId={messageInfoData._id}
          templateData={
            messageInfoData._id
              ? undefined
              : {
                  // Use template data if no draftId (for automated campaigns)
                  html: messageInfoData.html,
                  design: messageInfoData.design,
                  sender: messageInfoData.sender,
                  senderName: messageInfoData.senderName,
                  replyTo: messageInfoData.replyTo,
                  preheader: messageInfoData.preheader,
                  subject: messageInfoData.subject,
                }
          }
          setIsSendDraftModalOpen={setIsSendDraftModalOpen}
          shouldGetUpdatedHtml={true}
        />
      )}
      <PreviewDesignModal
        html={isLoadingPreview ? '' : html || messageInfoData.html}
        name={name}
        isVisible={isDesignPreviewModalVisible}
        onHide={() => setDesignPreviewModalVisiblity(false)}
      />
    </Header>
  );
};

export default BaseHeader;
